import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {BelegKetteDTO} from '../../openapi/fakturierung-openapi';


export class BelegKetteActions {

  public static loadBelegKette = createAction(
    '[BelegKette] Load beleg kette',
    props<{betriebId: string; belegId: string}>(),
  );

  public static loadBelegKetteSuccess = createAction(
    '[BelegKette] Load beleg kette success',
    props<{belegId: string; kette: BelegKetteDTO}>(),
  );

  public static loadBelegKetteFailure = createAction(
    '[BelegKette] Load beleg kette failure',
    props<{belegId: string; error: MappedHttpErrorResponse}>(),
  );
}
